import logoImage from "public/images/knicks/knicks-mock-logo.png";
import { routes } from "src/shared/routes";
import { TTeamConfig } from "src/shared/types/teamConfig.types";
import {
  FAQS,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
} from "./helper";

export const pass_check_in: TTeamConfig = {
  TEAM_SCHEMA: "pass_check_in",
  TEAM_FULL_NAME: "St Louis Blues",
  BROWSER_TITLE: "St. Louis Blues Pass",
  CLIENT_ID: "60ba98b2d08f.seasonshare.blues-blues.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#5b2c81",
    COLORS_SECONDARY: "#c4ced4",
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },
  },
  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Kings-Primary-Color_Logo.png",
  },

  LANGUAGES: {
    FAQS,
  },
};
